import React, { useEffect,useState, useRef } from 'react';
import { Wizard, NotificationList } from 'quanta-ui';
import {
  faTag,
  faMapMarkerAlt,
  faUser,
  faPlusCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Customer from './customer';
import RiskLocation from './risk_location';
// import { Loading } from '../../../../../lib/layout';
import { Loading } from 'quanta-flows/modules/layout';
import FinalisedQuote from './finalised_quote';
import AdditionalDetails from './additional_details';

export default function QuoteWizardPanel({
  lobCode,
  productName,
  productCode,
  quoteNumber,
  lobName,
  currentTab,
  expandedCards,
  role,
  status,
  setMoveToPlans,
  moveToPlans,
  ...props
}) {
  const [startStep, setStartStep] = useState(quoteNumber ? 2 : 0);
  // const startStep =
  //   currentTab !== undefined &&
  //   currentTab !== null &&
  //   currentTab !== ''
  //     ? currentTab
  //     : 0;
  const [proceedToRiskLocationPage, setProceedToRiskLocationPage] =
    useState(false);
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customLoadingMessage, setCustomLoadingMessage] =
    useState(null);
  const [buttonLabelCustomerTab, setButtonLabelCustomerTab] =
    useState(
      status &&
        ([
          'quote saved',
          'underwriter approved',
          'underwriter rejected',
          'converted to proposal',
        ]?.includes(status?.toString()?.toLowerCase()) ||
          (role?.toString()?.toLowerCase() !== 'underwriter' &&
            status?.toString()?.toLowerCase() ===
              'pending uw approval'))
        ? 'Proceed'
        : 'Save & Next',
    );
    useEffect(() => {
      if (moveToPlans) {
        setStartStep(2);
        setMoveToPlans(false);
      }
    }, [moveToPlans]);
  const renderExpandedCards = useRef(
    expandedCards && expandedCards?.length > 0
      ? expandedCards?.map((card) => {
          return {
            locationCard: false,
            stockLocationCards: card?.floaterLocations?.map(
              (loc) => false,
            ),
          };
        })
      : [
          {
            locationCard: true,
            stockLocationCards: [false],
          },
        ],
  );

  const renderExpandedCardsFloater = useRef({
    locationCard: true,
    floaterLocationCards: [false],
  });

  const steps = [
    {
      icon: <FontAwesomeIcon icon={faUser} size="lg" />,
      label: 'Customer',
      proceedLabel: () => buttonLabelCustomerTab,
      stepCompleted: () => proceedToRiskLocationPage,
      submitForm: async () => {
        if (props?.customerDetailsFormRef.current) {
          const res =
            await props?.customerDetailsFormRef.current.submitForm();
          return res;
        }
        return false;
      },
      stepNotCompleteAlert: () => {
        setAlerts([
          {
            header: 'Warning',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  Please fill in all the mandatory fields to proceed
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      component: ({ expanded }) =>
        expanded ? (
          loading ? (
            <div className={'min-h-screen'}>
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : (
            <Customer
              productCode={productCode}
              productName={productName}
              lobCode={lobCode}
              lobName={lobName}
              quoteNumber={quoteNumber}
              setProceedToRiskLocationPage={
                setProceedToRiskLocationPage
              }
              customerDetailsFormRef={props?.customerDetailsFormRef}
              setParentAlerts={setAlerts}
              setParentLoading={setLoading}
              setCustomLoadingMessage={setCustomLoadingMessage}
              renderExpandedCardsFloater={renderExpandedCardsFloater}
              renderExpandedCards={renderExpandedCards}
              role={role}
            />
          )
        ) : null,
    },
    {
      icon: <FontAwesomeIcon icon={faMapMarkerAlt} size={'lg'} />,
      label: 'Location & Coverage',
      proceedLabel: () => undefined,
      stepNotCompleteAlert: () => undefined,
      component: ({ expanded, goToStep }) =>
        expanded ? (
          loading ? (
            <div className={'min-h-screen'}>
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : (
            <RiskLocation
              goToStep={goToStep}
              productCode={productCode}
              productName={productName}
              lobCode={lobCode}
              quoteNumber={quoteNumber}
              lobName={lobName}
              riskLocationFormRef={props?.riskLocationFormRef}
              renderExpandedCards={renderExpandedCards}
              renderExpandedCardsFloater={renderExpandedCardsFloater}
              setParentAlerts={setAlerts}
              setCustomLoadingMessage={setCustomLoadingMessage}
              setParentLoading={setLoading}
              role={role}
            />
          )
        ) : null,
    },
    {
      icon: <FontAwesomeIcon icon={faPlusCircle} size="lg" />,
      label: 'Additional Details',
      proceedLabel: () => undefined,
      stepNotCompleteAlert: () => undefined,
      component: ({ expanded, goToStep }) =>
        expanded ? (
          loading ? (
            <div className={'min-h-screen'}>
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : (
            <AdditionalDetails
              goToStep={goToStep}
              productCode={productCode}
              productName={productName}
              lobCode={lobCode}
              quoteNumber={quoteNumber}
              lobName={lobName}
              additionalDetailsFormRef={
                props?.additionalDetailsFormRef
              }
              renderExpandedCards={renderExpandedCards}
              renderExpandedCardsFloater={renderExpandedCardsFloater}
              setParentAlerts={setAlerts}
              setCustomLoadingMessage={setCustomLoadingMessage}
              setParentLoading={setLoading}
              role={role}
              setButtonLabelCustomerTab={setButtonLabelCustomerTab}
            />
          )
        ) : null,
    },
    {
      icon: <FontAwesomeIcon icon={faTag} size={'lg'} />,
      label: 'Finalize',
      proceedLabel: () => undefined,
      stepNotCompleteAlert: () => undefined,
      component: ({ expanded, goToStep }) =>
        expanded ? (
          loading ? (
            <div className={'min-h-screen'}>
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : (
            <FinalisedQuote
              goToStep={goToStep}
              productCode={productCode}
              productName={productName}
              lobCode={lobCode}
              quoteNumber={quoteNumber}
              lobName={lobName}
              riskLocationFormRef={props?.riskLocationFormRef}
              renderExpandedCards={renderExpandedCards}
              renderExpandedCardsFloater={renderExpandedCardsFloater}
              setParentAlerts={setAlerts}
              setCustomLoadingMessage={setCustomLoadingMessage}
              setParentLoading={setLoading}
              role={role}
            />
          )
        ) : null,
    },
  ];

  return (
    <div className="min-h-full">
      <Wizard
        {...{
          steps,
          startStep,
          tabStyle: true,
          switchTabs: false,
          buttonSize: 'medium',
          showButtonPanel: !loading,
        }}
      />
      <div>
        <NotificationList {...{ items: alerts }} />
      </div>
    </div>
  );
}
